import { IAccountChangeStatus } from 'fitbeat.models';
import { IMappedPlan, PaymentService } from 'fitbeat.payment-service';
import { UserProfile } from '../../entities/user/userprofile';
import { UserProfileService } from '../user';
import { IChangeFunction } from './accountstatusmanager';

export class FamilyPlanSubscriptionToFamilyPlan implements IChangeFunction {
  public async validate(): Promise<IAccountChangeStatus> {
    return {
      fromStatus: 'FamilySubscription',
      toStatus: 'FamilySubscription',
      success: false,
      message: 'You are already linked to another family plan',
    };
  }

  public async change(
    userProfile: UserProfile,
    currentPlan: IMappedPlan,
    paymentService: PaymentService,
    userProfileService: UserProfileService,
    familyPlanOwnerUserProfileId?: string,
  ): Promise<any> {
    throw new Error('Called change using statuses that are not changeable FamilySubscription -> FamilySubscription');
  }
}
